import { z } from "zod";

export const DEFAULT_CURRENCY_CODE = "DZD";

export const LocaleSchema = z.enum(["en", "fr", "ar"]);
export type Locale = z.infer<typeof LocaleSchema>;

export const ItemTranslationSchema = z.object({
  locale: LocaleSchema,
  name: z.string().min(1).max(200),
  description: z.string().max(1000).default(""),
});
export type ItemTranslation = z.infer<typeof ItemTranslationSchema>;

export const MenuCategorySchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  slug: z.string().min(1).max(64),
  nameDefault: z.string().min(1).max(128),
  sortOrder: z.number().int().default(0),
  isActive: z.boolean().default(true),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type MenuCategory = z.infer<typeof MenuCategorySchema>;

export const MenuItemSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  categoryId: z.string().uuid().nullable(),
  sku: z.string().min(1).max(64),
  shortName: z.string().min(1).max(40).nullable().default(null),
  priceCents: z.number().int().nonnegative(),
  currency: z.string().length(3).default(DEFAULT_CURRENCY_CODE),
  imageUrl: z.string().url().nullable(),
  isAvailable: z.boolean().default(true),
  remainingToday: z.number().int().nonnegative().nullable().default(null),
  removableIngredients: z.array(z.string()).default([]),
  sortOrder: z.number().int().default(0),
  translations: z.array(ItemTranslationSchema).default([]),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  deletedAt: z.string().datetime().nullable().default(null),
});
export type MenuItem = z.infer<typeof MenuItemSchema>;

export const MenuSchema = z.object({
  categories: z.array(MenuCategorySchema),
  items: z.array(MenuItemSchema),
});
export type Menu = z.infer<typeof MenuSchema>;
